export default __webpack_public_path__ + "static/media/Bell.745b9946.svg";